var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "banner-module" },
    [
      _vm.showNextTemplateButton || _vm.selectedInstanceIndex
        ? _c(
            "div",
            { staticClass: "d-flex justify-content-between mb-3" },
            [
              _c(
                "b-button-group",
                { attrs: { size: "sm" } },
                [
                  _vm.showNextTemplateButton
                    ? _c(
                        "b-button",
                        {
                          attrs: { variant: "outline-primary" },
                          on: {
                            click: function ($event) {
                              return _vm.moveInstanceSelection(1)
                            },
                          },
                        },
                        [
                          _c("b-icon", { attrs: { icon: "arrow-down" } }),
                          _vm._v("\n        Next template\n      "),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.selectedInstanceIndex
                    ? _c(
                        "b-button",
                        {
                          attrs: { variant: "outline-primary" },
                          on: {
                            click: function ($event) {
                              return _vm.moveInstanceSelection(-1)
                            },
                          },
                        },
                        [
                          _vm._v("\n        Prev template\n        "),
                          _c("b-icon", { attrs: { icon: "arrow-up" } }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  _vm._s(_vm.totalTemplateOrder) +
                    "/" +
                    _vm._s(_vm.totalTemplatesCount)
                ),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-tabs",
        {
          attrs: {
            "content-class": "mt-3",
            pills: "",
            justified: "",
            small: "",
          },
        },
        [
          _c(
            "b-tab",
            { attrs: { title: "Content" } },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.canAddText(),
                      expression: "canAddText()",
                    },
                  ],
                  staticClass: "layout-sidebar-section",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "layout-sidebar-section-title",
                      on: {
                        click: function ($event) {
                          return _vm.$emit(
                            "toggleSection",
                            "textEditorFieldsSection"
                          )
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "d-flex align-items-center" }, [
                        _c("i", { staticClass: "bi bi-fonts green-fonts" }),
                        _vm._v(" "),
                        _c("strong", [_vm._v(" Text")]),
                      ]),
                      _vm._v(" "),
                      _c("b-icon", {
                        attrs: {
                          icon: _vm.isOpen.textEditorFieldsSection
                            ? "chevron-up"
                            : "chevron-down",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "transition",
                    { staticClass: "border-bottom" },
                    [
                      _c(
                        "b-collapse",
                        {
                          attrs: {
                            visible: _vm.isOpen.textEditorFieldsSection,
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              key: "text-section-" + _vm.editModeKey,
                              staticClass: "border-bottom pb-2 mb-2",
                            },
                            [
                              _vm._l(_vm.textFields, function (field, index) {
                                return _c(
                                  "b-form-group",
                                  {
                                    key: `${field.element_id}_${index}`,
                                    attrs: { "label-for": `field_${field.id}` },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "text-actions d-flex justify-content-between align-items-center mb-1",
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "font-medium text-xs",
                                          },
                                          [_vm._v(_vm._s(field.name))]
                                        ),
                                        _vm._v(" "),
                                        _c("i", {
                                          directives: [
                                            {
                                              name: "b-tooltip",
                                              rawName: "v-b-tooltip.hover.top",
                                              value: "Delete Text",
                                              expression: "'Delete Text'",
                                              modifiers: {
                                                hover: true,
                                                top: true,
                                              },
                                            },
                                          ],
                                          staticClass:
                                            "bi bi-x float-end cursor-pointer",
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleDeleteText(field)
                                            },
                                          },
                                        }),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      field.type === "Multi Line Text" &&
                                        (
                                          _vm.selectedInstance?.data?.[
                                            field.element_id
                                          ] || ""
                                        ).includes("\n")
                                        ? "b-textarea"
                                        : "b-input",
                                      {
                                        tag: "component",
                                        attrs: {
                                          id: `field_${field.element_id}`,
                                          value:
                                            _vm.selectedInstance.data[
                                              field.element_id
                                            ],
                                          "data-ai-agent-type":
                                            "input[type=text]",
                                          "data-ai-agent-id": `text-layer-input-${field.element_id}`,
                                          "data-ai-agent-label":
                                            "Text Layer Input",
                                          "data-ai-agent-role":
                                            "dynamic-text-input",
                                        },
                                        on: {
                                          focus: function ($event) {
                                            return _vm.setActiveObject(field)
                                          },
                                          input: function ($event) {
                                            return _vm.updateField(
                                              field,
                                              $event
                                            )
                                          },
                                          click: function ($event) {
                                            $event.stopPropagation()
                                          },
                                          blur: _vm.onBlurText,
                                        },
                                      }
                                    ),
                                  ],
                                  1
                                )
                              }),
                              _vm._v(" "),
                              _vm.canAddText()
                                ? _c("b-form-group", [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn custom-secondary-btn w-100 text-xs font-medium",
                                        attrs: {
                                          "data-ai-agent-type": "button",
                                          "data-ai-agent-id": "add-text-btn",
                                          "data-ai-agent-label": "Add Text",
                                        },
                                        on: { click: _vm.addNewTextField },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "bi bi-plus-lg",
                                        }),
                                        _vm._v(" Add Text\n                "),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.canAddDecorativeImages(),
                      expression: "canAddDecorativeImages()",
                    },
                  ],
                  staticClass: "layout-sidebar-section",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "layout-sidebar-section-title",
                      on: {
                        click: function ($event) {
                          return _vm.$emit(
                            "toggleSection",
                            "backgroundFieldsSection"
                          )
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "d-flex align-items-center" }, [
                        _c("i", { staticClass: "bi bi-palette green-fonts" }),
                        _vm._v(" "),
                        _c("strong", [_vm._v(" Background")]),
                      ]),
                      _vm._v(" "),
                      _c("b-icon", {
                        attrs: {
                          icon: _vm.isOpen.backgroundFieldsSection
                            ? "chevron-up"
                            : "chevron-down",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "transition",
                    { staticClass: "border-bottom" },
                    [
                      _c(
                        "b-collapse",
                        {
                          attrs: {
                            visible: _vm.isOpen.backgroundFieldsSection,
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              key: "background-section-" + _vm.editModeKey,
                              staticClass: "border-bottom pb-2 mb-2",
                            },
                            [
                              _c("b-form-group", [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex justify-content-between align-items-center flex-column",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "colors-item d-flex justify-content-between align-items-center",
                                      },
                                      [
                                        _c("label", { staticClass: "mb-1" }, [
                                          _c(
                                            "strong",
                                            {
                                              staticStyle: { color: "#209c86" },
                                            },
                                            [_vm._v("Color")]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.editor?.colors,
                                          function (color, index) {
                                            return _c(
                                              "div",
                                              {
                                                key: index,
                                                staticClass:
                                                  "d-flex align-items-center",
                                              },
                                              [
                                                _c("b-input", {
                                                  staticClass:
                                                    "color-fill-item w-10 no-right-border custom-color-picker",
                                                  attrs: {
                                                    debounce: "50",
                                                    type: "color",
                                                  },
                                                  on: {
                                                    update:
                                                      _vm.redrawBackground,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.editor.colors[index],
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editor.colors,
                                                        index,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editor.colors[index]",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("b-input", {
                                                  staticClass:
                                                    "w-100 no-left-border",
                                                  staticStyle: {
                                                    height: "38px",
                                                  },
                                                  attrs: { type: "text" },
                                                  on: {
                                                    change: function ($event) {
                                                      return _vm.onInputColor(
                                                        $event,
                                                        index
                                                      )
                                                    },
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.editor.colors[index],
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editor.colors,
                                                        index,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editor.colors[index]",
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex flex-row align-items-center mb-1 position-relative w-100",
                                        staticStyle: { "margin-top": "10px" },
                                      },
                                      [
                                        _c(
                                          "label",
                                          {
                                            staticClass: "mb-0 mr-2",
                                            staticStyle: {
                                              "min-width": "130px",
                                            },
                                          },
                                          [
                                            _c(
                                              "strong",
                                              {
                                                staticStyle: {
                                                  color: "#209c86",
                                                },
                                              },
                                              [_vm._v("Image")]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex flex-row justify-content-between flex-grow-1 image-multiselect",
                                            class: {
                                              "drag-over": _vm.isDragOver,
                                            },
                                            on: {
                                              dragenter: function ($event) {
                                                $event.preventDefault()
                                                return _vm.onDragEnter($event)
                                              },
                                              dragover: function ($event) {
                                                $event.preventDefault()
                                                return _vm.onDragOver($event)
                                              },
                                              drop: function ($event) {
                                                $event.preventDefault()
                                                return _vm.onDrop($event)
                                              },
                                            },
                                          },
                                          [
                                            _c("Multiselect", {
                                              staticClass:
                                                "background-dropdown flex-grow-1",
                                              attrs: {
                                                "track-by": "id",
                                                label: "name",
                                                placeholder: "",
                                                options:
                                                  _vm.getBackgroundFields,
                                              },
                                              on: {
                                                close: _vm.onBlurText,
                                                open: _vm.getFields,
                                              },
                                              scopedSlots: _vm._u([
                                                {
                                                  key: "singleLabel",
                                                  fn: function (props) {
                                                    return [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "background-dropdown-label",
                                                          on: {
                                                            mouseenter:
                                                              function (
                                                                $event
                                                              ) {
                                                                _vm.hoveredTag = true
                                                              },
                                                            mouseleave:
                                                              function (
                                                                $event
                                                              ) {
                                                                _vm.hoveredTag =
                                                                  null
                                                              },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "background-dropdown-label__image",
                                                            },
                                                            [
                                                              _c("img", {
                                                                staticClass:
                                                                  "preview-img",
                                                                attrs: {
                                                                  src: props
                                                                    .option
                                                                    .thumbnail,
                                                                  alt: props
                                                                    .option
                                                                    .name,
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      $event.stopPropagation()
                                                                      $event.preventDefault()
                                                                    },
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                },
                                                {
                                                  key: "option",
                                                  fn: function (props) {
                                                    return [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "background-dropdown-option",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "background-dropdown-option__image",
                                                            },
                                                            [
                                                              _c("img", {
                                                                attrs: {
                                                                  src: props
                                                                    .option
                                                                    .thumbnail,
                                                                  alt: props
                                                                    .option
                                                                    .name,
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "background-dropdown-option__text",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                              " +
                                                                  _vm._s(
                                                                    props.option
                                                                      .name
                                                                  ) +
                                                                  "\n                            "
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                },
                                                {
                                                  key: "caret",
                                                  fn: function () {
                                                    return [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "custom-arrow",
                                                        },
                                                        [
                                                          _c(
                                                            "svg",
                                                            {
                                                              attrs: {
                                                                xmlns:
                                                                  "http://www.w3.org/2000/svg",
                                                                width: "20",
                                                                height: "20",
                                                                viewBox:
                                                                  "0 0 24 24",
                                                                fill: "none",
                                                                stroke: "#333",
                                                                "stroke-width":
                                                                  "2",
                                                                "stroke-linecap":
                                                                  "round",
                                                                "stroke-linejoin":
                                                                  "round",
                                                              },
                                                            },
                                                            [
                                                              _c("polyline", {
                                                                attrs: {
                                                                  points:
                                                                    "6 9 12 15 18 9",
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ]),
                                              model: {
                                                value: _vm.selectedBackground,
                                                callback: function ($$v) {
                                                  _vm.selectedBackground = $$v
                                                },
                                                expression:
                                                  "selectedBackground",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "b-button",
                                              {
                                                staticClass:
                                                  "upload-button d-flex align-items-center justify-content-center",
                                                attrs: {
                                                  variant: "outline-primary",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    $event.preventDefault()
                                                    return _vm.onChange(
                                                      "selectBackground",
                                                      "Replace"
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("b-icon", {
                                                  attrs: { icon: "upload" },
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticStyle: {
                                                    "margin-left": "10px",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.canAddDecorativeImages(),
                      expression: "canAddDecorativeImages()",
                    },
                  ],
                  staticClass: "layout-sidebar-section",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "layout-sidebar-section-title",
                      on: {
                        click: function ($event) {
                          return _vm.$emit(
                            "toggleSection",
                            "aiGenerateFieldsSection"
                          )
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "d-flex align-items-center" }, [
                        _c("i", { staticClass: "bi bi-stars green-fonts" }),
                        _vm._v(" "),
                        _c("strong", [_vm._v(" AI Generate")]),
                      ]),
                      _vm._v(" "),
                      _c("b-icon", {
                        attrs: {
                          icon: _vm.isOpen.aiGenerateFieldsSection
                            ? "chevron-up"
                            : "chevron-down",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "transition",
                    { staticClass: "border-bottom" },
                    [
                      _c(
                        "b-collapse",
                        {
                          attrs: {
                            visible: _vm.isOpen.aiGenerateFieldsSection,
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "border-bottom pb-2 mb-2 scroll-images-section",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex flex-wrap align-items-center",
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-primary generate-background custom-gen",
                                    },
                                    [
                                      _c("i", { staticClass: "bi bi-stars" }),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "ml-2" }, [
                                        _vm._v("Generate Image"),
                                      ]),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "layout-sidebar-section" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "layout-sidebar-section-title",
                      on: {
                        click: function ($event) {
                          return _vm.$emit(
                            "toggleSection",
                            "productImagesFieldsSection"
                          )
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "d-flex align-items-center" }, [
                        _c("i", {
                          staticClass: "bi bi-file-earmark-image green-fonts",
                        }),
                        _vm._v(" "),
                        _c("strong", [_vm._v(" Product Images")]),
                      ]),
                      _vm._v(" "),
                      _c("b-icon", {
                        attrs: {
                          icon: _vm.isOpen.productImagesFieldsSection
                            ? "chevron-up"
                            : "chevron-down",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "transition",
                    { staticClass: "border-bottom" },
                    [
                      _c(
                        "b-collapse",
                        {
                          attrs: {
                            visible: _vm.isOpen.productImagesFieldsSection,
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "border-bottom pb-2 mb-2 scroll-images-section",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex flex-wrap align-items-center",
                                  class: {
                                    "drag-over": _vm.isDragOverProductImages,
                                  },
                                  on: {
                                    dragenter: function ($event) {
                                      $event.preventDefault()
                                      return _vm.onDragEnterProductImages.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                    dragover: function ($event) {
                                      $event.preventDefault()
                                      return _vm.onDragOverProductImages.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                    dragleave: function ($event) {
                                      $event.preventDefault()
                                      return _vm.onDragLeaveProductImages.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                    drop: function ($event) {
                                      $event.preventDefault()
                                      return _vm.onDropProductImage.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._l(
                                    _vm.getProductImages,
                                    function (image) {
                                      return _c(
                                        "div",
                                        {
                                          key: image.id,
                                          staticClass:
                                            "label-option general-card-template product-card-template",
                                          class: {
                                            selected:
                                              _vm.activeTarget?.id === image.id,
                                          },
                                          on: {
                                            drop: function ($event) {
                                              $event.stopPropagation()
                                              $event.preventDefault()
                                              return ((e) =>
                                                _vm.onDropReplaceProductImage(
                                                  e,
                                                  image
                                                )).apply(null, arguments)
                                            },
                                            dragover: function ($event) {
                                              $event.preventDefault()
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass: "close-btn",
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                  return _vm.handleProductDelete(
                                                    image
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "bi bi-trash3",
                                              }),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "button",
                                            {
                                              directives: [
                                                {
                                                  name: "b-tooltip",
                                                  rawName:
                                                    "v-b-tooltip.hover.viewport.noninteractive",
                                                  value: "Replace image",
                                                  expression: "'Replace image'",
                                                  modifiers: {
                                                    hover: true,
                                                    viewport: true,
                                                    noninteractive: true,
                                                  },
                                                },
                                              ],
                                              staticClass: "replace-image-btn",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.toggleProductDropdown(
                                                    image,
                                                    "replace"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "bi bi-repeat",
                                              }),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("img", {
                                            staticClass: "image-option",
                                            attrs: {
                                              src: image.thumbnail,
                                              alt: image.name,
                                            },
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                return _vm.setActiveObject(
                                                  image
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      )
                                    }
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex align-items-center justify-content-center additional-card-template",
                                      staticStyle: {
                                        width: "60px",
                                        height: "60px",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.toggleProductDropdown(
                                            null,
                                            "add"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        directives: [
                                          {
                                            name: "b-tooltip",
                                            rawName: "v-b-tooltip.hover.top",
                                            modifiers: {
                                              hover: true,
                                              top: true,
                                            },
                                          },
                                        ],
                                        staticClass:
                                          "fas fa-plus-circle add-icon",
                                        attrs: { title: "Add product images" },
                                      }),
                                    ]
                                  ),
                                ],
                                2
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.canAddDecorativeImages(),
                      expression: "canAddDecorativeImages()",
                    },
                  ],
                  staticClass: "layout-sidebar-section",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "layout-sidebar-section-title",
                      on: {
                        click: function ($event) {
                          return _vm.$emit(
                            "toggleSection",
                            "imagesFieldSection"
                          )
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "d-flex align-items-center" }, [
                        _c("i", {
                          staticClass: "bi bi-card-image green-fonts",
                        }),
                        _vm._v(" "),
                        _c("strong", [_vm._v("Images")]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "d-flex align-items-center" },
                        [
                          _vm.hasUnclassifiedImages
                            ? _c(
                                "b-button",
                                {
                                  staticClass: "mr-2 detect-text-btn",
                                  attrs: {
                                    size: "sm",
                                    variant: "outline-primary",
                                    disabled: _vm.isClassifyingTextImages,
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.handleDetectTextImages.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm.isClassifyingTextImages
                                    ? _c("b-spinner", { attrs: { small: "" } })
                                    : _c("i", { staticClass: "bi bi-fonts" }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "ml-1" }, [
                                    _vm._v("Detect Text"),
                                  ]),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("b-icon", {
                            attrs: {
                              icon: _vm.isOpen.imagesFieldSection
                                ? "chevron-up"
                                : "chevron-down",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "transition",
                    { staticClass: "border-bottom" },
                    [
                      _c(
                        "b-collapse",
                        { attrs: { visible: _vm.isOpen.imagesFieldSection } },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "border-bottom pb-2 mb-2 scroll-images-section",
                              on: {
                                drop: function ($event) {
                                  $event.preventDefault()
                                  return _vm.onDropAddImage.apply(
                                    null,
                                    arguments
                                  )
                                },
                                dragover: function ($event) {
                                  $event.preventDefault()
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  key: "images-section-" + _vm.editModeKey,
                                  staticClass:
                                    "d-flex flex-wrap align-items-center",
                                },
                                [
                                  _vm._l(_vm.getImages, function (image) {
                                    return _c(
                                      "div",
                                      {
                                        key: image.id,
                                        staticClass:
                                          "label-option general-card-template image-card-template",
                                        class: {
                                          selected:
                                            _vm.activeTarget?.id === image.id,
                                        },
                                        on: {
                                          drop: function ($event) {
                                            $event.stopPropagation()
                                            $event.preventDefault()
                                            return ((e) =>
                                              _vm.canEditImage(image) &&
                                              _vm.onDropReplaceLayoutImage(
                                                e,
                                                image
                                              )).apply(null, arguments)
                                          },
                                          dragover: function ($event) {
                                            $event.preventDefault()
                                          },
                                        },
                                      },
                                      [
                                        _vm.canEditImage(image)
                                          ? _c(
                                              "button",
                                              {
                                                staticClass: "close-btn",
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    return _vm.handleImageDelete(
                                                      image
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "bi bi-trash3",
                                                }),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.canEditImage(image)
                                          ? _c(
                                              "button",
                                              {
                                                directives: [
                                                  {
                                                    name: "b-tooltip",
                                                    rawName:
                                                      "v-b-tooltip.hover.viewport.noninteractive",
                                                    value: "Replace image",
                                                    expression:
                                                      "'Replace image'",
                                                    modifiers: {
                                                      hover: true,
                                                      viewport: true,
                                                      noninteractive: true,
                                                    },
                                                  },
                                                ],
                                                staticClass:
                                                  "replace-image-btn",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.replaceImage(
                                                      image,
                                                      "selectBackground",
                                                      "Replace"
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "bi bi-repeat",
                                                }),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.isTextOnlyImage(image)
                                          ? _c(
                                              "button",
                                              {
                                                directives: [
                                                  {
                                                    name: "b-tooltip",
                                                    rawName:
                                                      "v-b-tooltip.hover.viewport.noninteractive",
                                                    value:
                                                      "Convert to editable text",
                                                    expression:
                                                      "'Convert to editable text'",
                                                    modifiers: {
                                                      hover: true,
                                                      viewport: true,
                                                      noninteractive: true,
                                                    },
                                                  },
                                                ],
                                                staticClass: "convert-text-btn",
                                                attrs: {
                                                  disabled:
                                                    _vm.convertingImageId ===
                                                    image.id,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    return _vm.handleConvertToText(
                                                      image
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm.convertingImageId ===
                                                image.id
                                                  ? _c("b-spinner", {
                                                      attrs: { small: "" },
                                                    })
                                                  : _c("i", {
                                                      staticClass:
                                                        "bi bi-fonts",
                                                    }),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        !_vm.loaded
                                          ? _c(
                                              "div",
                                              { staticClass: "image-loader" },
                                              [
                                                _c("b-spinner", {
                                                  attrs: { small: "" },
                                                }),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("img", {
                                          staticClass: "image-option",
                                          class: { "is-loading": !_vm.loaded },
                                          attrs: {
                                            src: image.thumbnail,
                                            alt: image.name,
                                          },
                                          on: {
                                            load: _vm.onImageLoad,
                                            error: _vm.onImageLoad,
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              _vm.canEditImage(image) &&
                                                _vm.setActiveObject(image)
                                            },
                                          },
                                        }),
                                      ]
                                    )
                                  }),
                                  _vm._v(" "),
                                  _vm.canAddDecorativeImages()
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex align-items-center justify-content-center additional-card-template",
                                          on: {
                                            click: function ($event) {
                                              return _vm.addAdditionalField(
                                                "Background Theme Image"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            directives: [
                                              {
                                                name: "b-tooltip",
                                                rawName:
                                                  "v-b-tooltip.hover.top",
                                                modifiers: {
                                                  hover: true,
                                                  top: true,
                                                },
                                              },
                                            ],
                                            staticClass:
                                              "fas fa-plus-circle add-icon",
                                            attrs: { title: "Add images" },
                                          }),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "sticky-dropdown" },
                [
                  _c("span", [_vm._v("Apply to:")]),
                  _vm._v(" "),
                  _c("SelectTemplateDropdown", {
                    staticClass: "d-inline",
                    attrs: {
                      "local-storage-key":
                        _vm.LOCAL_STORAGE_KEY_SELECTED_TEMPLATES_FOR_TEXT,
                      "clear-local-storage": false,
                      "show-apply-button": true,
                    },
                    on: { apply: _vm.confirmApply },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("ProductImageDropdown", {
                ref: "productImageDropdownFields",
                attrs: {
                  "is-tab-active": false,
                  "is-file-image": _vm.options.isFileImage,
                  "is-fields-tab": true,
                },
                on: {
                  input: function ($event) {
                    return _vm.onChange("productImage", _vm.fileNameIds)
                  },
                  uploadInput: (fileIds) =>
                    _vm.onChange("productImage", {
                      productIds: fileIds,
                      type: "uploaded_product_image",
                    }),
                },
                model: {
                  value: _vm.fileNameIds,
                  callback: function ($$v) {
                    _vm.fileNameIds = $$v
                  },
                  expression: "fileNameIds",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.canAddText()
            ? _c("b-tab", { attrs: { title: "Style" } }, [
                _c("div", { staticClass: "mb-3" }, [
                  _c("label", [_c("strong", [_vm._v("Select Field")])]),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c("Multiselect", {
                        attrs: {
                          options: _vm.textFields,
                          multiple: true,
                          "track-by": "element_id",
                          label: "name",
                          placeholder: "Select...",
                          "close-on-select": false,
                        },
                        model: {
                          value: _vm.selected,
                          callback: function ($$v) {
                            _vm.selected = $$v
                          },
                          expression: "selected",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _vm.isTextField.length > 0 || _vm.selected.length > 0
                  ? _c(
                      "div",
                      [
                        _vm.options.colorSelector
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex align-items-center justify-content-between w-100 color-checkbox-container mb-3",
                              },
                              [
                                _c("label", { staticClass: "mb-0 mr-2" }, [
                                  _c("strong", [_vm._v("Color")]),
                                ]),
                                _vm._v(" "),
                                _c("ColorPicker", {
                                  attrs: {
                                    value: _vm.currentTarget?.fontColor,
                                    themes: _vm.themes,
                                    position: "top-start",
                                  },
                                  on: {
                                    input: function ($event) {
                                      return _vm.onTextChange(
                                        "fontColor",
                                        $event
                                      )
                                    },
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "b-form-row",
                          { staticClass: "mb-3" },
                          [
                            _c(
                              "b-col",
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: { disabled: _vm.target.locked },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "label",
                                          fn: function () {
                                            return [
                                              _c("strong", [
                                                _vm._v("Font Size"),
                                              ]),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      false,
                                      159817705
                                    ),
                                  },
                                  [
                                    _vm._v(" "),
                                    _c("b-form-input", {
                                      attrs: {
                                        value: _vm.config.fontSize,
                                        type: "number",
                                        min: "0",
                                      },
                                      on: {
                                        input: function ($event) {
                                          return _vm.onTextChange(
                                            "fontSize",
                                            $event
                                          )
                                        },
                                        keypress: _vm.preventNegativeInput,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          {
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "label",
                                  fn: function () {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex align-items-center justify-content-between",
                                        },
                                        [_c("strong", [_vm._v("Alignment")])]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              3671083065
                            ),
                          },
                          [
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "d-flex gap-2 mb-3" },
                              [
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "flex-grow-1",
                                    attrs: {
                                      variant:
                                        _vm.currentTarget?.textAlign ===
                                        "left,center"
                                          ? "primary"
                                          : "light",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.onTextChange(
                                          "textAlignment",
                                          `left,center`
                                        )
                                      },
                                    },
                                  },
                                  [_c("i", { staticClass: "bi bi-text-left" })]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "flex-grow-1",
                                    attrs: {
                                      variant:
                                        _vm.currentTarget?.textAlign ===
                                        "center,center"
                                          ? "primary"
                                          : "light",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.onTextChange(
                                          "textAlignment",
                                          `center,center`
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "bi bi-text-center",
                                    }),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "flex-grow-1",
                                    attrs: {
                                      variant:
                                        _vm.currentTarget?.textAlign ===
                                        "right,center"
                                          ? "primary"
                                          : "light",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.onTextChange(
                                          "textAlignment",
                                          `right,center`
                                        )
                                      },
                                    },
                                  },
                                  [_c("i", { staticClass: "bi bi-text-right" })]
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex align-items-center justify-content-between pb-2",
                              },
                              [_c("strong", [_vm._v("Text Spacing")])]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-input-group",
                              { staticClass: "mb-3" },
                              [
                                _c(
                                  "b-input-group-prepend",
                                  { staticClass: "pointer" },
                                  [
                                    _c(
                                      "b-input-group-text",
                                      { on: { click: _vm.decrease } },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "glyphicon glyphicon-minus",
                                        }),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("b-form-input", {
                                  staticStyle: { width: "94px" },
                                  attrs: {
                                    value: _vm.currentTarget?.charSpacing,
                                    type: "number",
                                    step: 1,
                                  },
                                  on: {
                                    input: function ($event) {
                                      return _vm.onTextChange(
                                        "textSpacing",
                                        $event
                                      )
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "b-input-group-append",
                                  { staticClass: "pointer" },
                                  [
                                    _c(
                                      "b-input-group-text",
                                      { on: { click: _vm.increase } },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "glyphicon glyphicon-plus",
                                        }),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex align-items-center justify-content-between mb-2 custom-shadow",
                              },
                              [
                                _c("strong", [_vm._v("Shadows")]),
                                _vm._v(" "),
                                _c("b-form-checkbox", {
                                  attrs: {
                                    id: "shadows-checkbox",
                                    "unchecked-value": false,
                                    switch: "",
                                    size: "lg",
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.$refs.textShadows.setEnabled(
                                        $event
                                      )
                                    },
                                  },
                                  model: {
                                    value: _vm.isShadowEnabled,
                                    callback: function ($$v) {
                                      _vm.isShadowEnabled = $$v
                                    },
                                    expression: "isShadowEnabled",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "transition",
                              [
                                _c(
                                  "b-collapse",
                                  { attrs: { visible: _vm.isShadowEnabled } },
                                  [
                                    _c("ShadowsModule", {
                                      ref: "textShadows",
                                      attrs: {
                                        target: _vm.currentTarget,
                                        "is-banner-builder": true,
                                        targets: _vm.targets,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("ApplyToAllTextDropdown", {
                          staticClass: "sticky-dropdown",
                          attrs: {
                            options: _vm.options,
                            target: _vm.currentTarget,
                            "is-banner-builder": true,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }